import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Switch, Route } from 'react-router-dom';
import { push } from 'connected-react-router';

// containers
import Success from './screens/Success';
import Fail from './screens/Fail';
import History from './screens/History';
import Details from './screens/Details';
import BillDetails from './screens/BillDetails';

/**
 * Orders
 */
 class Orders extends React.PureComponent {
  state = {
    routes: [
      {
        pathname: '/orders',
        component: History,
      },
      {
        pathname: '/orders/success',
        component: Success,
      },
      {
        pathname: '/orders/fail',
        component: Fail,
      },
      {
        pathname: '/orders/history',
        component: History,
      },
      {
        pathname: '/orders/details/:id',
        component: Details,
      },
      {
        pathname: '/orders/bill_details/:id',
        component: BillDetails,
      },
    ],
    width: '100%'
  }

  componentDidMount() {
    if (!this.props.auth.token) {
      this.props.push('/auth')
    }
  }


  render() {
    return (
      <>       
        <Switch>
          <div style={{ margin: 20}}>
          {
            this.state.routes.filter((r) => r.component !== '').map((route, i) => (
              <Route key={`route-${i}-${route.pathname}`} exact={true} path={route.pathname} component={route.component} />
            ))
          }
          </div>
        </Switch>
      </>
    )    
  }
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui,
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Orders));